<template>
  <div class="typeArea container">
    <div class="box">
        <div class="box-list">
            <div class="box-item box-item-qa" v-for="(item,index) in qaList" :key="index">
                <div class="box-item-top box-item-qa-top">
                    <el-image 
                      style="width: 305px; height: 430px"
                      :src="item.src[0]" 
                      :preview-src-list="item.src"
                      fit="cover"
                      ref="qaImgList">
                    </el-image>
                </div>
                <div class="split"></div>
                <div class="box-item-bottom">
                    <div>{{item.title}}</div>
                    <img @click="preview(index)" src="@/assets/images/image39.png" alt="">
                </div>
            </div>
            <div class="box-item box-item-qa"></div> <!-- 填充被删掉的一个元素 -->
        </div>
        <div class="pagination mg-top80">
            <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="dataList.total"
                :page-size="params.pageSize"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'honor',
  data () {
    return {
        params:{
            pageNum:1,
            pageSize:12,
        },
        dataList:{
            total: 12,
            list: [
                // {
                //     title: "管理体系认证证书",
                //     src: [
                //         require("@/assets/images/honor/group1/1.jpg"),
                //         require("@/assets/images/honor/group1/2.jpg"),
                //         require("@/assets/images/honor/group1/3.jpg")]
                // },
                // {
                //     title: "贵州省病原微生物实验室BSL-2",
                //     src: [
                //         require("@/assets/images/honor/group2/1.jpg"),
                //         require("@/assets/images/honor/group2/2.jpg")]
                // },
                // {
                //     title: "化学品物理危险性鉴定机构",
                //     src: [
                //         require("@/assets/images/honor/group3/1.jpg"),
                //         require("@/assets/images/honor/group3/2.jpg")]
                // },
                {
                    title: "CMA检验检测机构资质认定证书",
                    src: [require("@/assets/images/honor/1.jpg")]
                },
                {
                    title: "CNAS GLP良好实验室规范符合性证书",
                    src: [require("@/assets/images/honor/2.jpg")]
                },
                {
                    title: "CNAS实验室认可证书",
                    src: [require("@/assets/images/honor/3.jpg")]
                },
                // {
                //     title: "贵阳市检验检测与认证行业协会会员证书",
                //     src: [require("@/assets/images/honor/4.jpg")]
                // },
                {
                    title: "知识产权管理体系认证证书",
                    src: [require("@/assets/images/honor/11.png")]
                },
                // {
                //     title: "化学品测试机构",
                //     src: [require("@/assets/images/honor/5.jpg")]
                // },
                {
                    title: "化妆品注册和备案检验机构",
                    src: [require("@/assets/images/honor/6.jpg")]
                },
                {
                    title: "农药登记试验单位",
                    src: [require("@/assets/images/honor/7.jpg")]
                },
                {
                    title: "实验动物使用许可证（SPF）",
                    src: [require("@/assets/images/honor/8.jpg")]
                },
                {
                    title: "公告",
                    src: [require("@/assets/images/honor/13.png")]
                },
                {
                    title: "声明",
                    src: [require("@/assets/images/honor/sm.png")]
                },
                // {
                //     title: "实验动物使用许可证",
                //     src: [require("@/assets/images/honor/9.jpg")]
                // },
                // {
                //     title: "知识产权管理体系认证证书",
                //     src: [require("@/assets/images/honor/10.jpg")]
                // },
            ],
        },
        qaList:[]
    }
  },
  methods: {
    preview(index){
        this.$refs.qaImgList[index].clickHandler();
    },
    handleCurrentChange(page){
        this.qaList = this.dataList.list.slice((page-1)*12,page*12)
    }
  },
  mounted(){
    this.handleCurrentChange(1)
  }
}
</script> 

<style lang='less' scoped>
    .container{
        padding-bottom: 80px;
        .box{
            .box-list{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .box-item-qa{
                    width: 345px;
                    height: 551px;
                    .box-item-qa-top{
                        width: 345px;
                        height: 470px;
                    }
                }
                .box-item{
                    margin-top: 20px;
                    // box-sizing: border-box;
                    position: relative;
                    &:hover{
                        .split{
                            border-top: 2px solid #DB0000;
                        }
                    }
                    .box-item-top{
                        padding: 20px;
                        background-color: #FCFCFC;
                        box-sizing: border-box;
                    }
                    .split{
                        border-top: 1px solid #CCCCCC;
                        position: absolute;
                        top: 470px;
                        width: 345px;
                        // transition: .5s ease all;
                    }
                    .box-item-bottom{
                        width: 345px;
                        height: 80px;
                        padding: 26px 20px;
                        background-color: #FCFCFC;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-between;
                        font-size: 15px;
                        align-items: center;
                        img{
                            cursor: pointer;
                        }
                    }
                }
            }

        }
    }
</style>
